module.exports = __webpack_public_path__ + "static/media/natapp.ecec5ea9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/natapp.png
// module id = 151
// module chunks = 0